// extracted by mini-css-extract-plugin
export default {"post":"Post_post__xnt1j","post__content":"Post_post__content__l5R04","post__btn":"Post_post__btn__jzm7k"};